module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Home-heart-59cb0bbe898a4075994b425bee9c5685.svg";